export class Db {
  databaseName: string;
  serverName: string;
  data: any;

  constructor(database?: string, server?: string, data?: any) {
    this.databaseName = database;
    this.serverName = server;
    this.data = data;
  }
}

export class UserDb {
  databaseName: string;
  connectionStringName: string;
}
